import { withJsonFormsControlProps } from '@jsonforms/react';
import { Email } from './Email';

const EmailControl = ({ data, handleChange, path, schema, errors, visible, label }) => {
  return (
    <Email
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      description={schema?.description ?? ''}
      errors={errors}
      visible={visible}
      label={label}
    />
  );
};

export default withJsonFormsControlProps(EmailControl);
